export default {
    PROFILE: {
        proxy: 'mb-ui-profile',
        id: 'profile',
    },
    TRANSFERS:{
        proxy:  'mb-ui-transfers',
        id: 'transfers',
    },
    ACCOUNTS:{
        proxy:  'mb-ui-accounts',
        id: 'accounts',
    },
};
